import React, { useEffect, useState } from 'react';
import './Navbar.css';
import navlogo from '../Assets/fab hub logo (tm).png';
import navprofileIcon from '../Assets/logout.svg';

const Navbar = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("adminToken");
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("adminToken");
    window.location.href = "/admin/login"; 
  };
  
  return (
    <div className='navbar'>
      <img src={navlogo} className='nav-logo' alt="Logo" />
      <h1>Aavryaa's Admin Panel</h1>
      {isLoggedIn && (
        <img
          src={navprofileIcon}
          className='nav-profile'
          alt="Logout"
          onClick={handleLogout}
          title="Logout"
          style={{ cursor: "pointer" }}
        />
      )}
    </div>
  );
};

export default Navbar;
